import { Component } from 'react';
import { connect } from 'react-redux';
import { history } from 'Helpers/history';
import routesPath from 'Constants/routes.constants';

class NotFound extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isShow: false,
            moduleName: '',
            moduleUrl: '',
        };
    }

    componentDidUpdate(prevProps) {
        if(prevProps.profile.id !== this.props.profile.id) {
            this.setState({
                isShow: true,
                moduleName: 'Dashboard',
                moduleUrl: routesPath.root
            })
        }
    }

    render() {
        const { isShow, moduleName, moduleUrl } = this.state;
        return isShow && (
            <div className='importdata-container'>
                <div className='dataupload-block'>
                    <p>{ 'No Access' }</p>
                    <div className='upload-data'>
                        <button type='button' onClick={ () => history.push(moduleUrl) }>{ 'Back to ' + moduleName }</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
  const { profile } = state
  return ({
    profile,
  });
};

export default connect(mapStateToProps)(NotFound);
